<template>
  <div class="grid">
    <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="#274461"
      :is-full-page="fullPage"
    ></loading>
    <Toast />
    <ConfirmPopup></ConfirmPopup>
    <div class="col-12 sticky">
      <div id="custom_card" class="card">
        <div class="grid justify-content-between">
          <div class="col-12 md:col-6">
            <div
              class="flex flex-wrap align-items-center justify-content-center md:justify-content-start md:mb-0 mb-3"
            >
              <p style="color: #3f51b5; font-size: 20px; font-weight: 600">
                {{ $t("application_details") }}
              </p>
            </div>
          </div>
          <div class="col-12 md:col-6">
            <div
              class="flex flex-wrap align-items-center justify-content-end md:justify-content-end md:mb-0 mb-3"
            >
              <Button
                @click="back"
                class="p-button-danger"
                :label="$t('goback')"
                icon="pi pi-angle-double-left"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="grid p-fluid">
          <div class="col-8 md:col-8">
            <div class="card">
              <div class="grid justify-content-between">
                <div class="col-12 md:col-8">
                  <h4 class="mb-0">
                    {{ $t("application_no") }} :
                    {{ Details.application_no ? Details.application_no : "" }}
                  </h4>
                </div>
                <div class="col-12 md:col-4">
                  <h5 class="mb-0">
                    {{ $t("application_date") }} :
                    {{ Details.date ? dateFormatDMY(Details.date) : "" }}
                  </h5>
                </div>
              </div>
              <hr v-if="Details?.application_no" />
              <!-- <div class="row">
                <div class="col-md-12">
                  <b class="mb-0"
                    >✅ {{ $t("mobile_no") }} :
                    {{ Details.mobile_no ? Details.mobile_no : "" }}</b
                  >
                </div>
              </div>
              <hr /> -->
              <!-- <div class="row">
                    <div class="col-md-12">
                        <b class="mb-0">✅ {{ $t('email') }} : {{ Details?.application_details?.email }}</b>
                    </div>
                </div>
                <hr> -->
              <div class="row">
                <div class="col-md-12">
                  <b class="mb-0"
                    >✅ {{ $t("adhar_no") }} :
                    {{ Details?.application_details?.adhar_no }}</b
                  >
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-md-12">
                  <b class="mb-0"
                    >✅ {{ $t("city") }} :
                    {{ Details?.application_details?.city }}</b
                  >
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-md-12">
                  <b class="mb-0"
                    >✅ {{ $t("full_address") }} :
                    {{ Details?.application_details?.address }}</b
                  >
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-md-12">
                  <b class="mb-0"
                    >✅ {{ $t("pan_no") }} :
                    {{ Details?.application_details?.pan_no }}</b
                  >
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-md-12">
                  <b class="mb-0"
                    >✅ {{ $t("pincode") }} :
                    {{ Details?.application_details?.pincode }}</b
                  >
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-md-12">
                  <b class="mb-0"
                    >✅ {{ $t("state") }} :
                    {{ Details?.application_details?.state }}</b
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-4 md:col-4">
            <div class="card">
              <div class="card-body">
                <div class="d-flex flex-column align-items-center text-center">
                  <img
                    v-if="
                      Details?.application_details?.profile_image &&
                      Details?.application_details?.profile_image != ''
                    "
                    :src="Details?.application_details?.profile_image"
                    class="rounded-circle"
                    width="150"
                    height="150"
                    style="margin-top: 15%;"
                  />
                  <img
                    v-else
                    class="rounded-circle"
                    width="150"
                    :src="barImage()"
                    style="margin-top: 15%;"
                  />
                  <div class="mt-3">
                    <h4>
                      {{
                        Details?.applicant_name ? Details?.applicant_name : ""
                      }}
                    </h4>
                    <p class="text-secondary mb-1">
                      ✅ {{ $t("applicant_mobile") }} :
                      {{ Details?.mobile_no ? Details?.mobile_no : "" }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <b>{{ $t("document_details") }} :</b>
        <div class="p-fluid formgrid grid" style="height: 400px">
          <div class="field col-4 md:col-4">
            <hr />
            <div class="p-fluid formgrid grid">
              <div class="field col-6 md:col-6">
                <b class="mb-0">✅ {{ $t("adharcard") }}</b>
              </div>
              <div class="field col-3 md:col-3"></div>
              <div class="field col-3 md:col-3">
                <Button
                  :label="$t('view')"
                  class="p-button-rounded p-button-success mr-2"
                  v-tooltip.bottom="$t('view')"
                  @click="
                    ViewDOC(Details?.application_details?.documents?.adharcard)
                  "
                />
              </div>
            </div>
            <hr v-if="Details?.application_details?.documents?.adharcard" />
            <div class="p-fluid formgrid grid">
              <div class="field col-6 md:col-6">
                <b class="mb-0">✅ {{ $t("pancard") }}</b>
              </div>
              <div class="field col-3 md:col-3">
                <Button
                  :label="$t('frontside')"
                  class="p-button-rounded p-button-success mr-2"
                  v-tooltip.bottom="$t('view')"
                  @click="
                    ViewDOC(Details?.application_details?.documents?.pancard[0])
                  "
                />
              </div>
              <div class="field col-3 md:col-3">
                <Button
                  :label="$t('backside')"
                  class="p-button-rounded p-button-success mr-2"
                  v-tooltip.bottom="$t('view')"
                  @click="
                    ViewDOC(Details?.application_details?.documents?.pancard[1])
                  "
                />
              </div>
            </div>
            <hr v-if="Details?.application_details?.documents?.pancard" />
            <!-- <DataTable :value="Details?.application_details?.documents">
                        <Column field="Document" header="view">
                            <template #body="{ data }">
                            {{ data }}
                        </template>
</Column>
<Column :header="$t('action')" headerStyle="min-width:10rem;">
    <template #body="slotProps">
                                <Button
                                    icon="pi pi-eye"
                                    class="p-button-rounded p-button-success mr-2"
                                    v-tooltip.bottom="$t('view')"
                                    @click="ViewDOC(slotProps.data)"
                                />
                            </template>
</Column>
</DataTable> -->
          </div>
          <div class="field col-8 md:col-8">
            <iframe
              :src="`${file}#zoom=50`"
              style="width: 100%; height: 100%; border: none"
              frameborder="0"
            ></iframe>
          </div>
        </div>
      </div>
      <div class="card">
        <b>{{ $t("application_history") }} :</b>
        <Divider />
        <DataTable :value="application_history">
          <template #empty>
            <b style="text-align: center">{{ $t("no_rec") }}</b>
          </template>
          <Column field="status_name" :header="$t('status')"> </Column>
          <Column field="status_date" :header="$t('date')">
            <template #body="{ data }">
              {{ dateFormatDMY(data.status_date) }}
            </template>
          </Column>
          <Column field="remark" :header="$t('remark')"></Column>
          <Column
            field="reject_reason_name"
            :header="$t('rejectreason')"
          ></Column>
          <Column field="user_name" :header="$t('user')"></Column>
        </DataTable>
      </div>
      <div class="card" v-if="application_status_dropdown.length > 0">
        <b>{{ $t("application_approval") }} :</b>
        <Divider />
        <div class="col-12">
          <div class="p-fluid formgrid grid">
            <div class="field col-3 md:col-3">
              <Dropdown
                id="application_status"
                v-model="application_status_selected"
                :options="application_status_dropdown"
                :value="application_status_dropdown._id"
                :optionLabel="$t('langinfo')"
                filter
                :placeholder="$t('select_application_status')"
                optionValue="_id"
                @change="handleApplicationStatusChange"
              >
              </Dropdown>
            </div>
            <div class="field col-3 md:col-3" v-if="showRejectDropdown">
              <Dropdown
                id="application_reject"
                v-model="application_reject_selected"
                :options="application_reject_dropdown"
                :value="application_reject_dropdown._id"
                :optionLabel="$t('langname')"
                filter
                :placeholder="$t('select_rejection_reason')"
              >
              </Dropdown>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="p-fluid formgrid grid">
            <div class="field col-6 md:col-6">
              <span class="p-float-label">
                <Textarea format="text" v-model="remark" rows="6"> </Textarea>
                <label>{{ $t("remark") }}</label>
              </span>
            </div>
          </div>
        </div>
        <div style="text-align: center">
          <Button
            :label="$t('save')"
            @click="Submit()"
            icon="pi pi-check"
            class="p-button-success"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import apis from "@/apis";
import axios from "axios";
export default {
  name: "MahatakrarApplicationApproval",
  data() {
    return {
      remark: "",
      file: "",
      application_history: [],
      Details: [],
      isLoadingModel: false,
      fullPage: true,
      product: "",
      FromPage: "Application",
      showRejectDropdown: false,
      application_status_selected: "",
      application_reject_selected: "",
      application_status_dropdown: [],
      application_reject_dropdown: [],
    };
  },
  watch: {
    currentLocale() {
      this.schemeapplicationhistory(this.product._id);
    },
  },
  async mounted() {
    if (localStorage.getItem("product")) {
      this.product = await JSON.parse(localStorage.getItem("product"));
      localStorage.setItem("product", "");
      this.get_ApplicationStatusMaster();
      this.schemeapplicationhistory(this.product._id);
      this.schemeapplicationlistbyid(this.product._id);
      this.FromPage = this.product.FromPage;
    } else {
      this.$toast.add({
        severity: "error",
        summary: "Error!!!",
        detail: "Details Not Found",
        life: 3000,
      });
      return false;
    }
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
  },
  methods: {
    barImage() {
      return "images/pic.jpg";
    },
    ViewDOC(path) {
      this.file = path;
    },
    dateFormatDMY(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == "NaN-NaN-NaN") {
          return postdate;
        } else {
          let date = ("0" + inputDate.getDate()).slice(-2);
          // current month
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
          // current year
          let year = inputDate.getFullYear();
          if (date.toString() == "aN") {
            return postdate;
          } else {
            return date + "/" + month + "/" + year;
          }
        }
      } else {
        return "";
      }
    },
    Submit() {
      if (!this.application_status_selected) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("select_application_status"),
          life: 3000,
        });
        return false;
      }
      var data = {
        lang: this.$i18n.locale,
        application_no: this.product.application_no,
        client_id: localStorage.getItem("client_id"),
        user_id: localStorage.getItem("id"),
        status: this.application_status_selected,
        reject_reason: this.showRejectDropdown
          ? this.application_reject_selected._id
          : null,
        remark: this.remark,
      };
      this.isLoadingModel = true;
      var promise = apis.updateApplicationStatus(data);
      promise.then((response) => {
        this.isLoadingModel = false;
        if (response.data.status == true) {
          this.$toast.add({
            severity: "success",
            summary: "success",
            detail: response.data.message,
            life: 3000,
          });
          this.application_status_selected = "";
          this.application_reject_selected = "";
          this.remark = "";
          this.get_ApplicationStatusMaster();
          this.schemeapplicationhistory(this.product._id);
          this.schemeapplicationlistbyid(this.product._id);
        } else {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: response.data.message,
            life: 3000,
          });
        }
      });
    },
    back() {
      this.$router.push({
        name: this.FromPage,
      });
    },
    async schemeapplicationhistory(_id) {
      var data = {
        _id: _id,
        lang: this.$i18n.locale,
      };
      var promise = apis.schemeapplicationhistory(data);
      promise.then((response) => {
        this.application_history = response.data.data;
      });
    },
    async schemeapplicationlistbyid(_id) {
      var data = {
        _id: _id,
        lang: this.$i18n.locale,
      };
      var promise = apis.schemeapplicationlistbyid(data);
      promise.then((response) => {
        var temp = response.data.data;
        if (temp.length > 0) {
          this.Details = temp[0];
        }
      });
    },
    async get_ApplicationStatusMaster() {
      var data = {
        role_id: localStorage.getItem("role_id"),
        status_id: this.product.status,
        lang: this.$i18n.locale,
      };
      //console.log("data1",data)
      var promise = apis.getApplicationRoleStatusMapping(data);
      promise.then((response) => {
        this.application_status_dropdown = response.data.data;
      });
    },
    handleApplicationStatusChange() {
      const selectedStatus = this.application_status_dropdown.find(
        (status) => status._id === this.application_status_selected
      );
      this.getapplicationRejectReason();
      this.showRejectDropdown = selectedStatus?.is_reject || false;
      if (this.showRejectDropdown) {
        this.getapplicationRejectReason();
      } else {
        this.application_reject_selected = null;
      }
    },
    async getapplicationRejectReason() {
      var data = {};
      var promise = apis.getApplicationRejectionReason(data);
      promise.then((response) => {
        this.application_reject_dropdown = response.data.data;
      });
    },
  },
};
</script>